module.exports = __webpack_public_path__ + "0da9e7764e2bff77c1d74f72c9471f5e.gif";